import * as Long from "long";
import { ofType } from "redux-observable";
import { EMPTY, of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { IdPersistence } from "../../../constants/IdPersistence";
import { selectPlayerInfo } from "../../../selectors/selectPlayerInfo";
import { selectIsRankingAvailable, selectRunningTournamentInfo, selectTournamentPlayerRankings, } from "../../../selectors/selectTournamentInfo";
import { PersistenceMode } from "../../../utils/PersistenceMode";
import { utilPersistence } from "../../../utils/utilPersistence";
import { utilTime } from "../../../utils/utilTime";
import { EventType } from "../../balancing/types/BalancingCore";
import { actionGetCoopLeagueRanking, actionGetPlayerLeagueRanking, TypeActionTournament, } from "../actionTournament";
export var epicTournamentGetRankings = function (action$, state$) {
    return action$.pipe(ofType(TypeActionTournament.SelectTournamentDialog), switchMap(function () {
        var state = state$.value;
        var lastTimeRankingsDownloaded = utilPersistence.getValue(IdPersistence.LastRankingUpdate);
        var now = utilTime.now();
        var elapsedTime = utilTime.secondsElapsedSince(lastTimeRankingsDownloaded) || 0;
        var tournamentRankings = selectTournamentPlayerRankings(state);
        // This is a countdown required by server, for reference check issue BFHW-415.
        // The second check wasn't explicitly required, but it makes sense to check.
        if ((tournamentRankings.length !== 0 && elapsedTime <= 30) ||
            !selectIsRankingAvailable(state)) {
            return EMPTY;
        }
        utilPersistence.setValue(IdPersistence.LastRankingUpdate, now, PersistenceMode.Write);
        var playerInfo = selectPlayerInfo(state);
        var tournamentInfo = selectRunningTournamentInfo(state);
        if (tournamentInfo === undefined ||
            !selectIsRankingAvailable(state) ||
            playerInfo.playerId === undefined ||
            tournamentInfo.proto.eventId === undefined ||
            tournamentInfo.balancing === undefined ||
            (tournamentInfo.balancing.type === EventType.CoopLeague &&
                (playerInfo.coopId === undefined || Long.ZERO.equals(playerInfo.coopId)))) {
            return EMPTY;
        }
        switch (tournamentInfo.balancing.type) {
            case EventType.CoopLeague: {
                return of(actionGetCoopLeagueRanking(playerInfo.coopId, tournamentInfo.proto.eventId, playerInfo.playerId));
            }
            case EventType.PlayerLeague: {
                return of(actionGetPlayerLeagueRanking(tournamentInfo.proto.eventId, playerInfo.playerId));
            }
            default: {
                return EMPTY;
            }
        }
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/epics/epicTournamentGetRankings.ts
// module id = 2444
// module chunks = 3